import React from "react"
import { navigate } from "gatsby"

export default class NavigateToTransformLink extends React.PureComponent {
  render() {
    const transform = this.props.transform;
    return <React.Fragment>
      <a href={`#preview_${transform.slug}`} onClick={(e) => {
        e.preventDefault();
        navigate(`${window.location.pathname}#preview_${transform.slug}`)
      }} dangerouslySetInnerHTML={{
        __html: transform.label
      }} aria-label={transform.label} />{` `}
    </React.Fragment>;
  }
}
